import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import hiTranslations from './locales/hi.json';

const savedLang = localStorage.getItem('kisaanLang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      hi: {
        translation: hiTranslations
      }
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('kisaanLang', lng);
  document.documentElement.lang = lng;
});

export default i18n;


